"use strict";
/**
 * Содержимое изображений с других доменов не может быть получены через канвас
 * Пытаемся грузить через установку crossOrigin
 * Если не получается - изображения не могут быть обработаны на клиенте вообще
 */
Fotobook.cors = {
    // todo: возможно, понадобится поддержка урла в качестве входного параметра
    getImage: function(img){
        return new Promise((resolve, reject) => {
            let src = img.src,
                parser = Fotobook.urlParser;

            parser.href = src;

            if (img.crossOrigin === undefined || parser.host === window.location.host){
                resolve(img);
                return;
            }

            let cors = document.createElement("img");

            cors.crossOrigin = "Anonymous";
            cors.onload = function(e){
                resolve(this);
            };
            cors.onerror = reject;
            cors.src = src;
        });
    },
};
